'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OverlayTrigger = require('./OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('./Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FitItemsPopover = function (_React$Component) {
  _inherits(FitItemsPopover, _React$Component);

  function FitItemsPopover(props) {
    _classCallCheck(this, FitItemsPopover);

    var _this = _possibleConstructorReturn(this, (FitItemsPopover.__proto__ || Object.getPrototypeOf(FitItemsPopover)).call(this, props));

    _this.state = {
      secondLineItemIndex: -1
    };
    _this.itemsRef = [];
    _this.alignItems = _this.alignItems.bind(_this);
    _this.checkRef = _this.checkRef.bind(_this);
    return _this;
  }

  _createClass(FitItemsPopover, [{
    key: 'alignItems',
    value: function alignItems() {
      var firstBottom = this.itemsRef[0].offsetTop + this.itemsRef[0].offsetHeight;
      for (var i = 1; i < this.itemsRef.length; i++) {
        if (this.itemsRef[i].offsetTop + this.itemsRef[i].offsetHeight > firstBottom) {
          this.setState({
            secondLineItemIndex: i
          });
          return;
        }
      }
      this.setState({
        secondLineItemIndex: this.itemsRef.length
      });
    }
  }, {
    key: 'checkRef',
    value: function checkRef() {
      if (this.itemsRef.length === this.props.items.length) {
        this.alignItems();
      } else {
        this.timeOutId = setTimeout(this.alignItems, 10);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.itemsRef.length === this.props.items.length && this.props.items.length > 0) {
        this.alignItems();
      } else if (this.props.items.length > 0) {
        this.checkRef();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          maxWidth = _props.maxWidth,
          className = _props.className,
          popoverPlacement = _props.popoverPlacement,
          popoverClassName = _props.popoverClassName,
          items = _props.items,
          title = _props.title;

      if (items.length === 0) {
        return null;
      }
      var style = Object.assign({}, style, { maxWidth: maxWidth });
      var itemsStyle = {
        flex: this.state.secondLineItemIndex === -1 ? '0 0 100%' : '0 0 auto'
      };
      var val = items.map(function (item, i) {
        if (_this2.state.secondLineItemIndex === -1 || _this2.state.secondLineItemIndex > i) {
          return _this2.state.secondLineItemIndex !== i + 1 ? _react2.default.createElement(
            'span',
            { key: i, ref: function ref(_ref) {
                return _this2.itemsRef[i] = _ref;
              } },
            item,
            ', '
          ) : _react2.default.createElement(
            'span',
            { key: "fit-items-popover--items" + i, ref: function ref(_ref2) {
                return _this2.itemsRef[i] = _ref2;
              } },
            item
          );
        }
        return;
      });
      var popoverClick = _react2.default.createElement(
        _Popover2.default,
        { title: title, className: 'fit-items-popover__main' },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)("fit-items-popover__content", popoverClassName) },
          items.map(function (item, i) {
            if (_this2.state.secondLineItemIndex !== -1 && _this2.state.secondLineItemIndex <= i) {
              return _react2.default.createElement(
                'div',
                { key: i },
                item
              );
            }
            return;
          })
        )
      );
      return _react2.default.createElement(
        'div',
        { style: style, className: (0, _classnames2.default)("fit-items-popover", className) },
        _react2.default.createElement(
          'div',
          { style: itemsStyle, className: 'fit-items-popover--items' },
          val
        ),
        items.length - this.state.secondLineItemIndex !== 0 && _react2.default.createElement(
          'div',
          { className: 'fit-items-popover--btn' },
          _react2.default.createElement(
            _OverlayTrigger2.default,
            { rootClose: true, trigger: 'click', placement: popoverPlacement, overlay: popoverClick },
            _react2.default.createElement(
              'button',
              { className: 'btn btn-default' },
              '+',
              items.length - this.state.secondLineItemIndex
            )
          )
        )
      );
    }
  }]);

  return FitItemsPopover;
}(_react2.default.Component);

FitItemsPopover.propTypes = {
  maxWidth: _propTypes2.default.string,
  popoverPlacement: _propTypes2.default.string,
  popoverClassName: _propTypes2.default.string,
  title: _propTypes2.default.string,
  items: _propTypes2.default.array
};

FitItemsPopover.defaultProps = {
  items: [],
  popoverPlacement: 'top',
  title: ''
};

exports.default = FitItemsPopover;